module.exports = __webpack_public_path__ + "static/media/LT3.2dd005ea.jpg";